// All of the requested modules are loaded behind enumerable getters.
const map = Object.defineProperties({}, {
  "./(auth)/_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(auth)/_layout.tsx"); } },
  "./(auth)/forgot-password.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(auth)/forgot-password.tsx"); } },
  "./(auth)/login.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(auth)/login.tsx"); } },
  "./(auth)/register.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(auth)/register.tsx"); } },
  "./(auth)/update-password.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(auth)/update-password.tsx"); } },
  "./(tabs)/_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(tabs)/_layout.tsx"); } },
  "./(tabs)/assinatura.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(tabs)/assinatura.tsx"); } },
  "./(tabs)/grupos.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(tabs)/grupos.tsx"); } },
  "./(tabs)/index.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(tabs)/index.tsx"); } },
  "./(tabs)/profile.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(tabs)/profile.tsx"); } },
  "./(tabs)/rachas/[id].tsx": { enumerable: true, get() { return require("/vercel/path0/app/(tabs)/rachas/[id].tsx"); } },
  "./(tabs)/rachas/_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/app/(tabs)/rachas/_layout.tsx"); } },
  "./+not-found.tsx": { enumerable: true, get() { return require("/vercel/path0/app/+not-found.tsx"); } },
  "./_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/app/_layout.tsx"); } },
  "./blog/[slug].tsx": { enumerable: true, get() { return require("/vercel/path0/app/blog/[slug].tsx"); } },
  "./blog/[slug].web.tsx": { enumerable: true, get() { return require("/vercel/path0/app/blog/[slug].web.tsx"); } },
  "./blog/_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/app/blog/_layout.tsx"); } },
  "./blog/index.tsx": { enumerable: true, get() { return require("/vercel/path0/app/blog/index.tsx"); } },
  "./blog/index.web.tsx": { enumerable: true, get() { return require("/vercel/path0/app/blog/index.web.tsx"); } },
  "./contato.tsx": { enumerable: true, get() { return require("/vercel/path0/app/contato.tsx"); } },
  "./index.tsx": { enumerable: true, get() { return require("/vercel/path0/app/index.tsx"); } },
  "./pix.tsx": { enumerable: true, get() { return require("/vercel/path0/app/pix.tsx"); } },
  "./politica-privacidade.tsx": { enumerable: true, get() { return require("/vercel/path0/app/politica-privacidade.tsx"); } },
  "./racha/[id]/_layout.tsx": { enumerable: true, get() { return require("/vercel/path0/app/racha/[id]/_layout.tsx"); } },
  "./racha/[id]/index.tsx": { enumerable: true, get() { return require("/vercel/path0/app/racha/[id]/index.tsx"); } },
  "./sobre.tsx": { enumerable: true, get() { return require("/vercel/path0/app/sobre.tsx"); } },
  "./success.tsx": { enumerable: true, get() { return require("/vercel/path0/app/success.tsx"); } },
  "./termos-de-uso.tsx": { enumerable: true, get() { return require("/vercel/path0/app/termos-de-uso.tsx"); } },
  "./test.tsx": { enumerable: true, get() { return require("/vercel/path0/app/test.tsx"); } },
});

function metroContext(request) {
    return map[request];
}

// Return the keys that can be resolved.
metroContext.keys = function metroContextKeys() {
  return Object.keys(map);
};

// Return the module identifier for a user request.
metroContext.resolve = function metroContextResolve(request) {
  throw new Error('Unimplemented Metro module context functionality');
}

module.exports = metroContext;